<app-button
    type="stroked"
    (buttonClick)="toggle()"
    [icon]="toggleFlag ? icon1 : icon2"
    [buttonText]="toggleFlag ? label1 : label2"
></app-button>
